export default __webpack_public_path__ + "static/media/3.e5989a52.png";